import { ArrayNotEmpty, IsIn, IsInt, IsOptional, IsBoolean } from 'class-validator';

import { OrderStatusTxt } from '../order-status';

export type OrderPositionListRequestRaw = {
    areaId: string | number;
    orderStatusList: OrderStatusTxt[];
    skipCompleted?: boolean;
};

export class OrderPositionListRequest {
    @IsInt()
    public areaId: number;

    @IsIn(['new', 'pending', 'work', 'closed', 'shipped'] satisfies OrderStatusTxt[], { each: true })
    @ArrayNotEmpty()
    public orderStatusList: OrderStatusTxt[];

    @IsOptional()
    @IsBoolean()
    public skipCompleted?: boolean;

    constructor(data?: Partial<OrderPositionListRequestRaw>) {
        this.areaId = typeof data?.areaId === 'number' ? data.areaId : parseInt(data?.areaId, 10);
        this.orderStatusList = data?.orderStatusList;
        this.skipCompleted = data?.skipCompleted;
    }
}
